import { FC, useEffect } from "react";
import {
  Heading,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Container,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PageHead } from "../../../home/components/PageHead";
import { FuncButton } from "../../../customComponents/components/FuncButton";
import { useToken } from "./../../../auth/hooks/useToken";
import { useTravelList } from "../../hooks";
import { head } from "../../helpers";
import { TableHead } from "../../../home/components/TableHead";

export const Travel: FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const user_id = urlParams.get("user_id");
  const navigate = useNavigate();
  const [token] = useToken();
  const { travelList, travelLoading, getTravelList } = useTravelList(user_id);

  useEffect(() => {
    let interval = setInterval(() => {
      getTravelList(true);
    }, 5000);
    return () => clearInterval(interval);
  }, [getTravelList]);

  const handleCreateTravel = () => {
    navigate("/travel_set");
  };
  
  if (token === null) {
    return <Navigate replace to="/login" />;
  }
  return (
    <>
      <PageHead
        breadCrumbs={<Heading>Поездки</Heading>}
        onClick={handleCreateTravel}
        linkLabel="Создать поездку"
      >
        {travelLoading ? (
          <Container height="calc(100vh - 240px)">
            <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
          </Container>
        ) : (
          <TableHead column={head}>
            {travelList?.map(
              ({
                id,
                date_start,
                date_end,
                vehicle_title,
                user_full_name,
                price,
              }) => (
                <Tr key={id}>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {id}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {date_start} - {date_end}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {vehicle_title}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {user_full_name}
                    </Text>
                  </Td>
                  <Td>
                    <Text fontSize="sm" color="#121419">
                      {price}
                    </Text>
                  </Td>
                  {/* <Td style={{ position: "relative" }}>
                    {money}
                    {isAccept && <IsAccept>ТРЕБУЕТ ПОДТВЕРЖДЕНИЯ</IsAccept>}
                  </Td> */}
                  <Td>
                    <FuncButton
                      onClick={() => {
                        navigate(`/travel_set/${id}`);
                      }}
                    >
                      РЕДАКТИРОВАТЬ
                    </FuncButton>
                  </Td>
                </Tr>
              )
            )}
          </TableHead>
        )}
      </PageHead>
    </>
  );
};
